// @flow
import CategoryItem from './CategoryItem';

export default CategoryItem;
